"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCookieWithDomain = exports.setCookie = exports.getCookie = void 0;
function getCookie(name) {
    const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
exports.getCookie = getCookie;
function setCookie(name, value = undefined, options = {}) {
    if (value === undefined)
        return;
    options = Object.assign({ 'path': '/', 'max-age': 3600 * 24 * 30 }, options);
    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
    for (const optionKey in options) {
        updatedCookie += "; " + optionKey;
        const optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }
    document.cookie = updatedCookie;
}
exports.setCookie = setCookie;
function setCookieWithDomain(name, value = undefined, options = {}) {
    let { host, port } = location;
    host = host.replace(`:${port}`, '');
    const domainParts = host.split('.');
    if (domainParts.length === 1) {
        setCookie(name, value, options);
        return;
    }
    let domain = '.' + domainParts.slice(-2).join('.');
    setCookie(name, value, Object.assign({ 'domain': domain }, options));
    if (getCookie(name) == null || getCookie(name) != value) {
        domain = '.' + domainParts.slice(-3).join('.');
        setCookie(name, value, Object.assign({ 'domain': domain }, options));
    }
}
exports.setCookieWithDomain = setCookieWithDomain;
